import { IKnmSearchClipped } from 'APIPackage/KnmSearchModule/interfaces/IKnmSearchClipped';
import { TableColumnSortEnum } from 'CorePackage/MainModule/enums/TableColumnSortEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { SearchKnmTableCell } from '../components/SearchKnmTableCell';

export const initialKnmSearchTableColumns: ITableColumn<IKnmSearchClipped>[] = [
  {
    id: 'number',
    name: 'УЧЕТНЫЙ НОМЕР КНМ',
    sort: TableColumnSortEnum.NONE,
    isDisabledSort: true,
    renderCell: SearchKnmTableCell,
  },
  {
    id: 'knmType',
    name: 'ТИП КНМ',
    sort: TableColumnSortEnum.NONE,
    isDisabledSort: false,
    renderCell: SearchKnmTableCell,
  },
  {
    id: 'inn',
    name: 'ИНН',
    sort: TableColumnSortEnum.NONE,
    isDisabledSort: true,
    renderCell: SearchKnmTableCell,
  },
  {
    id: 'ogrn',
    name: 'ОГРН',
    sort: TableColumnSortEnum.NONE,
    isDisabledSort: true,
    renderCell: SearchKnmTableCell,
  },
  {
    id: 'faceName',
    name: 'НАИМЕНОВАНИЕ ПРОВЕРЯЕМОГО ЛИЦА',
    sort: TableColumnSortEnum.NONE,
    isDisabledSort: true,
    renderCell: SearchKnmTableCell,
  },
  {
    id: 'startMonth',
    name: 'МЕСЯЦ НАЧАЛА ПРОВЕДЕНИЯ КНМ',
    sort: TableColumnSortEnum.NONE,
    isDisabledSort: false,
    renderCell: SearchKnmTableCell,
  },
  {
    id: 'term',
    name: 'СРОК ПРОВЕДЕНИЯ КНМ',
    sort: TableColumnSortEnum.NONE,
    isDisabledSort: false,
    renderCell: SearchKnmTableCell,
  },
  {
    id: 'objectAddress',
    name: 'МЕСТО НАХОЖДЕНИЯ ОБЪЕКТА',
    sort: TableColumnSortEnum.NONE,
    isDisabledSort: true,
    renderCell: SearchKnmTableCell,
  },
  {
    id: 'frguOrgName',
    name: 'НАИМЕНОВАНИЕ ОРГАНА ГОСУДАРСТВЕННОГО КОНТРОЛЯ (НАДЗОРА)',
    sort: TableColumnSortEnum.NONE,
    isDisabledSort: true,
    renderCell: SearchKnmTableCell,
  },
  {
    id: 'inspectionTarget',
    name: 'ЦЕЛЬ ПРОВЕДЕНИЯ КНМ',
    sort: TableColumnSortEnum.NONE,
    isDisabledSort: true,
    renderCell: SearchKnmTableCell,
  },
  {
    id: 'carryoutName',
    name: 'ВИД КНМ',
    sort: TableColumnSortEnum.NONE,
    isDisabledSort: false,
    renderCell: SearchKnmTableCell,
  },
  {
    id: 'prosecName',
    name: 'НАИМЕНОВАНИЕ ОРГАНА ПРОКУРАТУРЫ',
    sort: TableColumnSortEnum.NONE,
    isDisabledSort: true,
    renderCell: SearchKnmTableCell,
  },
];
